export default __webpack_public_path__ + "static/3b70700473676feea0f72f80fb361069.jpg";